import { Routes } from "@angular/router";

/**
 * There is no routing in this application: the widget is mounted by the root template, not by an
 * outlet. The router is provided all the same, because the widget reads the query parameters
 * through `ActivatedRoute`, and a route config that matches everything and renders nothing is
 * what keeps the initial navigation from failing to match.
 *
 * It deliberately no longer names the widget as a route component. Mounted that way it would
 * receive no inputs, and the domain is an input now: an outlet added later would get a widget
 * that has no domain and says so, instead of one quietly serving the anonymous audience.
 */
export const routes: Routes = [{ path: "**", children: [] }];
